import React, { Component } from "react";
import { getDashboardStats, getTopRecipes } from "../../api/api";
import "./AdminDashboard.css";

class AdminDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: null,
      topRecipes: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.loadDashboard();
  }
  formatTime = (seconds) => {
    if (!seconds) return "0s";
  
    const total = parseFloat(seconds);
  
    const mins = Math.floor(total / 60);
    const secs = Math.floor(total % 60);
  
    return `${mins}m ${secs}s`;
  };
  loadDashboard = async () => {
    try {
      const statsRes = await getDashboardStats();
      const recipesRes = await getTopRecipes();
  
      console.log("StatsRes:", statsRes);
      console.log("RecipesRes:", recipesRes);
  
      this.setState({
        stats: statsRes?.data || {},
        topRecipes: recipesRes?.data || [],
        loading: false,
      });
  
    } catch (err) {
      console.error("Dashboard Error:", err);
      this.setState({ loading: false });
    }
  };
  render() {
    const { stats, topRecipes, loading } = this.state;

    if (loading) return <p>Loading...</p>;
    if (!stats) return <p>No data</p>;

    return (
      <div className="dashboard-container">

        <h1>📊 Admin Dashboard</h1>

        {/* STATS */}
        
        <div className="stats-grid">
          <div className="stat-card">
            <h3>Total Users</h3>
            <p>{stats?.totalUsers || 0}</p>
          </div>

          <div className="stat-card">
            <h3>Active Users</h3>
            <p>{stats.activeUsers}</p>
          </div>

          <div className="stat-card">
            <h3>New Users</h3>
            <p>{stats.newUsers}</p>
          </div>

          <div className="stat-card">
            <h3>Avg Engagement</h3>
            <p>{this.formatTime(stats?.avgEngagementTime)}</p>
          </div>
        </div>

        {/* TOP RECIPES */}
        <div className="top-recipes">
  <h2>🔥 Top Recipes</h2>

  {topRecipes?.length > 0 ? (
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>Recipe</th>
          <th>Views</th>
        </tr>
      </thead>

      <tbody>
        {topRecipes.map((r, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td>{r.name}</td>
            <td>{r.views}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>No recipe data</p>
  )}
</div>

      </div>
    );
  }
}

export default AdminDashboard;